import { Navigate } from "react-router-dom";
import React, { Suspense } from "react";
import { Skeleton } from "baseui/skeleton";
import { BacnetExplorerPage, BuildingInsightsPage, BuildingsMapPage, ObjectsCreatePage } from ".";
import { PageLayout } from "../layouts/PageLayout/PageLayout";
import { ErrorPage } from "./";
import UserDetails from "./UserDetails";
import Test from "./Test";

const AlarmClassesPage = React.lazy(() => import('./AlarmClasses'));
const DashboardPage = React.lazy(() => import('./Dashboard'));
const BimPage = React.lazy(() => import('./Bim'));
const AlarmsPage = React.lazy(() => import('./Alarms'));
const AlarmDetailsPage = React.lazy(() => import('./AlarmDetails'));
const AlarmJournalPage = React.lazy(() => import('./AlarmJournal'));
const AlarmClassEditPage = React.lazy(() => import('./AlarmClassEdit'));
const AlarmClassNewPage = React.lazy(() => import('./AlarmClassNew'));
const ObjectDetailsPage = React.lazy(() => import('./ObjectDetails'));
//const ObjectsCreatePage = React.lazy(() => import('./ObjectsCreate'));
const QrScanPage = React.lazy(() => import('./QrScan'));
//const BacnetExplorerPage = React.lazy(() => import('./BacnetExplorer'));
const ObjectsPage = React.lazy(() => import('./Objects'));

const LoadingAnimation = () => {
    return (<div>
        <Skeleton animation rows={1} />
        <Skeleton animation rows={1} />
        <Skeleton animation rows={3} />
      </div>)
    }
//<Navigate replace to="/objects" />
export const routes = [
    {
        path: '/',
        element: <PageLayout></PageLayout>,
        errorElement: <ErrorPage></ErrorPage>,
        children: [
            {
                index: true, 
                element: <Navigate replace to="/objects" />
            },
            {
                path: '/auth-response',
                element: <Navigate replace to="/objects" />
            },
            {
                path: '/objects',
                element: <Suspense fallback={<LoadingAnimation />}><ObjectsPage /></Suspense>
            },
            {
                path: '/objects/:resourceGroupId/:objectId',
                element: <Suspense fallback={<LoadingAnimation />}><ObjectDetailsPage></ObjectDetailsPage></Suspense>
            },
            {
                path: '/alarms',
                element: <Suspense fallback={<LoadingAnimation />}><AlarmsPage></AlarmsPage></Suspense>
            },
            {
                path: '/alarms/:resourceGroupId/:alarmId',
                element: <Suspense fallback={<LoadingAnimation />}><AlarmDetailsPage></AlarmDetailsPage></Suspense>
            },
            {
                path: '/alarms/journal',
                element: <Suspense fallback={<LoadingAnimation />}><AlarmJournalPage></AlarmJournalPage></Suspense>
            },
            {
                path: '/alarmClasses',
                element: <Suspense fallback={<LoadingAnimation />}><AlarmClassesPage></AlarmClassesPage></Suspense>
            },
            {
                path: '/alarmClasses/:alarmClassId',
                element: <Suspense fallback={<LoadingAnimation />}><AlarmClassEditPage></AlarmClassEditPage></Suspense>
            },
            {
                path: '/alarmClasses/new',
                element: <Suspense fallback={<LoadingAnimation />}><AlarmClassNewPage></AlarmClassNewPage></Suspense>
            },
            {
                path: '/addnewobjects',
                element: <Suspense fallback={<LoadingAnimation />}><ObjectsCreatePage></ObjectsCreatePage></Suspense>
            },
            {
                path: '/QRCode',
                element: <Suspense fallback={<LoadingAnimation />}><QrScanPage></QrScanPage></Suspense>
            },
            {
                path: '/bim',
                element: <Suspense fallback={<LoadingAnimation />}><BimPage></BimPage></Suspense>
            },
            {
                path: '/bim/:bimId',
                element: <Suspense fallback={<LoadingAnimation />}><BimPage></BimPage></Suspense>
            },
            {
                path: '/dashboards',
                element: <Suspense fallback={<LoadingAnimation />}><DashboardPage></DashboardPage></Suspense>                                                                                                                                                                                                        
            },
            {
                path: '/edgedevices/:edgeDeviceId/:deviceId/:moduleId',
                element: <Suspense fallback={<LoadingAnimation />}><BacnetExplorerPage></BacnetExplorerPage></Suspense>
            },
            {
                path: '/users/me',
                element: <Suspense fallback={<LoadingAnimation />}><UserDetails></UserDetails></Suspense>
            },
            {
                path: '/buildinginsights',
                element: <Suspense fallback={<LoadingAnimation />}><BuildingInsightsPage /></Suspense>
            },
            {
                path: '/buildingsmap',
                element: <Suspense fallback={<LoadingAnimation />}><BuildingsMapPage /></Suspense>
            },
            /*{
                path: '/test',
                element: <Test></Test>
            }*/
        ]
    }
];

